import React, { useEffect, useState } from 'react'
import { CBadge, CButton, CCard, CCardBody, CCardFooter, CCol, CForm, CFormLabel, CRow } from '@coreui/react';
import { useLocation, useNavigate } from 'react-router-dom';
import { createBooths, deleteBooths, updateBooths } from 'src/services/Booths/Booths';
import { CFormInput, CHeader } from '@coreui/react';
import { Toaster } from 'src/components/Toaster';

export default function BoothActions() {
  const location = useLocation();
  const navigate = useNavigate();

    const [props, setProps] = useState(location.state?.item ? [location.state.item] : [])
    const [price, setPrice] = useState(location.state?.item?.price ?? 30000)
    const [maintenance, setMaintenance] = useState(location.state?.item?.maintenance ?? 0)
    const [rollCount, setRollCount] = useState(location.state?.item?.rollCount ?? 0)
    const [printCount, setPrintCount] = useState(location.state?.item?.printCount ?? 0)
    const [merchantId, setMerchantId ] = useState(location.state?.item?.merchantID ?? 0)
    const [open, setOpen] = useState(false)
    const [message, setMessage] = useState("")
    const [color, setColor] = useState("")

  // function testSnackBar(){
  //   setMessage("test")
  //   setOpen(true)
  // }

  async function handleOnClick(action) {
    if (action === 'Save') {
      const data = {
        id: props[0].id,
        price: price,
        maintenance: maintenance,
        rollCount: rollCount,
        printCount: printCount,
        merchantID: merchantId
      };

      const update = await updateBooths(data);

      if (update.success === 1) {
        setMessage(update.message)
        setOpen(true)
        const data = () =>
          setTimeout(() => {
            navigate(-1);
          }, 2000);

        data();

        return clearTimeout(data);
      } else {
        setMessage(update.message)
        setOpen(true)
        setColor("red")
      }
    } else {
      const data = {
        price: price,
        maintenance: maintenance,
        rollCount: rollCount,
        printCount: printCount,
        merchantID: merchantId
      };

      const update = await createBooths(data);

      if (update.success === 1) {
        setMessage(update.message)
        setOpen(true)
        const data = () =>
          setTimeout(() => {
            navigate(-1);
          }, 2000);

        data();

        return clearTimeout(data);
      } else {
        setMessage(update.message)
        setOpen(true)
        setColor("red")
      }
    }
  }

  async function handleDelete() {
    const data = {
      id: props[0].id
    };

    const deleteBooth = await deleteBooths(data);

    if (deleteBooth.success === 1) {
      setMessage(deleteBooth.message)
      setOpen(true)
      const data = () =>
        setTimeout(() => {
          navigate(-1);
        }, 2000);

      data();

      return clearTimeout(data);
    }
  }

    return (
        <div>
            <CCard>
              <Toaster
                open={open}
                message={message}
                setOpen={setOpen}
                ahd={1500}
                color={color}
              />
                <CHeader style={{marginLeft:"1vw"}}><strong>{JSON.stringify(props) === JSON.stringify([]) ? "Add" : "Edit"} Booth</strong></CHeader>

                <CCardBody style={{display:"flex", flexWrap:"wrap", width:"100%"}}>
                {
                    JSON.stringify(props) === JSON.stringify([]) ? <></> : 
                    <CHeader style={{width:"100%"}}>
                        <CRow>
                            <p><strong>Merchant Name</strong>: {props[0]?.merchantName}</p>
                            <p><strong>Merchant Address</strong>: {props[0]?.merchantAddress}</p>
                            <p><strong>Merchant PIC</strong>: {props[0]?.picName}</p>
                            <p><strong>Merchant PIC Phone</strong>: {props[0]?.picPhone ?? "-"}</p>
                        </CRow>
                    </CHeader>
                }

                {/* <CForm onSubmit={(e) => handleSubmit(e)} noValidate validated={validated}> */}
                    <div style={{width:"100%", marginRight:"3%", marginTop:"2vh"}}>
                        <CRow style={{width:"100%"}}>
                            <CCol xs={3}>
                                <CFormLabel>Price  <span><CBadge color="warning">Required</CBadge></span> </CFormLabel>                        
                            </CCol>
                            <CCol xs={9}>
                                <CFormInput style={{width:"100%"}} value={price} type="number" onChange={(e)=>{setPrice(e.target.value)}}/>
                            </CCol>
                        </CRow>
                    </div>
                    <div style={{width:"100%", marginBottom:"2vh", marginRight:"3%", marginTop:"2vh"}}>
                        <CRow style={{width:"100%"}}>
                            <CCol xs={3}>
                                <CFormLabel>Maintenance  </CFormLabel>
                            </CCol>
                            <CCol xs={9}>
                                <CFormInput style={{width:"100%"}} value={maintenance} type="number" onChange={(e)=>{setMaintenance(e.target.value)}}/>
                            </CCol>
                        </CRow>
                    </div>
                    <div style={{width:"100%", marginBottom:"2vh", marginRight:"3%"}}>
                        <CRow style={{width:"100%"}}>
                            <CCol xs={3}>            
                                <CFormLabel>Roll Count </CFormLabel>
                            </CCol>
                            <CCol xs={9}>
                                <CFormInput style={{width:"100%"}} value={rollCount} type="number" onChange={(e)=>{setRollCount(e.target.value)}}/>
                            </CCol>
                        </CRow>
                    </div>
                    <div style={{width:"100%", marginBottom:"2vh", marginRight:"3%"}}>
                        <CRow style={{width:"100%"}}>
                            <CCol xs={3}>                        
                                <CFormLabel>Print Count </CFormLabel>
                            </CCol>
                            <CCol xs={9}>
                                <CFormInput style={{width:"100%"}} value={printCount} type="number" onChange={(e)=>{setPrintCount(e.target.value)}}/>
                            </CCol>
                        </CRow>
                    </div>
                    <div style={{width:"100%", marginBottom:"2vh", marginRight:"3%"}}>
                        <CRow style={{width:"100%"}}>
                            <CCol xs={3}>
                                <CFormLabel>Merchant ID <span><CBadge color="warning">Required</CBadge></span></CFormLabel>                            
                            </CCol>
                            <CCol xs={9}>
                                <CFormInput style={{width:"100%"}} value={merchantId} type="number" onChange={(e)=>{setMerchantId(e.target.value)}}/>
                            </CCol>
                        </CRow>
                    </div>
                    {/* </CForm> */}
                </CCardBody>
                <CCardFooter style={{textAlign:"right", width:"100%"}}>
                    <CButton style={{backgroundColor: "green", border:"none", marginRight:"1vw", marginLeft:"1vw"}}  onClick={()=>{handleOnClick(JSON.stringify(props) === JSON.stringify([]) ? "Add" : "Save")}}>{JSON.stringify(props) === JSON.stringify([]) ? "Add" : "Save"} Data</CButton>
                    {/* <CButton style={{backgroundColor: "green", border:"none", marginRight:"1vw", marginLeft:"1vw"}}  onClick={testSnackBar}>{JSON.stringify(props) === JSON.stringify([]) ? "Add" : "Save"} Data</CButton> */}
                    {JSON.stringify(props) === JSON.stringify([]) ? <></> : 
                        <CButton style={{backgroundColor: "red", border:"none"}} onClick={()=>{handleDelete()}}>Delete Data</CButton>
                    }
                </CCardFooter>
            </CCard>
        </div>
    )
}
